import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { EquipmentService } from '../../_services/http/equipment.service';
import {
  EquipmentState,
  loadEquipmentsAction,
  loadEquipmentsErrorAction,
  loadEquipmentsSuccessAction,
  selectIsEquipmentInitialized,
} from './equipement.store';

@Injectable()
export class EquipementEffect {
  constructor(
    private service: EquipmentService,
    private actions$: Actions,
    private store: Store<EquipmentState>
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadEquipmentsAction),
      withLatestFrom(this.store.select(selectIsEquipmentInitialized)),
      filter(([action, isInitialized]) => !isInitialized),
      mergeMap(() =>
        this.service.all().pipe(
          map((payload) => loadEquipmentsSuccessAction({ payload })),
          catchError(() => of(loadEquipmentsErrorAction()))
        )
      )
    )
  );
}
